import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/coupon_definitions',
  component: Management,
  redirect: '/coupon_definitions/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/coupon_definitions/List'),
      redirect: 'list/enabled',
      meta: {
        auth: Auth.listCouponDefinitions
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/coupon_definitions/ListTable'),
          meta: {
            auth: Auth.listCouponDefinitions,
            tabName: 'all'
          }
        },
        {
          path: 'enabled',
          component: () => import('@/views/coupon_definitions/ListTable'),
          meta: {
            auth: Auth.listCouponDefinitions,
            tabName: 'enabled'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/coupon_definitions/New'),
      meta: {
        auth: Auth.createCouponDefinition
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/coupon_definitions/Edit'),
      meta: {
        auth: Auth.updateCouponDefinition
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/coupon_definitions/DetailLayout'),
      meta: {
        auth: Auth.showCouponDefinition
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/coupon_definitions/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showCouponDefinition
          }
        },
        {
          path: 'coupons',
          component: () => import('@/views/coupon_definitions/details/Coupons'),
          meta: {
            tabName: 'coupons', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showCouponDefinition
          }
        }
      ]
    }
  ]
}
